module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('mu-appbar', {
    attrs: {
      "title": "Settings"
    }
  }, [_c('mu-icon-button', {
    staticClass: "backButton",
    attrs: {
      "icon": "arrow_back"
    },
    on: {
      "click": _vm.backToAppView
    },
    slot: "left"
  })], 1), _vm._v(" "), _c('mu-list', [_c('mu-divider'), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "describeText": _vm._f("toMinutes")(_vm.myWorkDuration, 'Work Duration')
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "access_alarm"
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-slider', {
    attrs: {
      "step": 60,
      "min": 60,
      "max": 3600
    },
    model: {
      value: (_vm.myWorkDuration),
      callback: function($$v) {
        _vm.myWorkDuration = $$v
      },
      expression: "myWorkDuration"
    }
  })], 1), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "describeText": _vm._f("toMinutes")(_vm.myBreakDuration, 'Break Duration')
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "videogame_asset"
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-slider', {
    attrs: {
      "step": 60,
      "min": 60,
      "max": 3600
    },
    model: {
      value: (_vm.myBreakDuration),
      callback: function($$v) {
        _vm.myBreakDuration = $$v
      },
      expression: "myBreakDuration"
    }
  })], 1), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "title": "Push Notifications",
      "describeText": _vm.notificationSettingDescription
    }
  }, [_c('mu-switch', {
    attrs: {
      "disabled": _vm.disableNotificationSetting
    },
    slot: "right",
    model: {
      value: (_vm.myAllowNotification),
      callback: function($$v) {
        _vm.myAllowNotification = $$v
      },
      expression: "myAllowNotification"
    }
  })], 1), _vm._v(" "), _c('mu-divider')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4516fb98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SettingsView.vue
// module id = 87
// module chunks = 1